//
import { mapActions, mapState } from 'vuex'
import {
    ModelAutocomplete,
    ModelDataTable,
    ModelForm,
} from '@/components/reusable_components/next'
import xlsxUtils from '@/mixins/XlsxUtils'

//
import ProductModel from '@/models/Warehouse/WhProduct'
import StockMovementModel from '@/models/Warehouse/WhStockMovement'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
import fields from './fields'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'product-list',
    components: {
        ModelAutocomplete,
        ModelDataTable,
        ModelForm,
    },
    computed: {
        /**
         *
         */
        autocompleteProps() {
            return {
                model: ProductModel,
            }
        },

        /**
         *
         */
        currentParams() {
            return {
                filter: this.$refs.table ? this.$refs.table.currentFilter : {},
                get_all_results: true,
            }
        },

        /**
         *
         */
        formData() {
            return this.selected
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields,
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                service: StockMovementModel,
                filters: filters({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                }),
                headers,
                initialFilterValues: {
                    wh_warehouse_id: this.warehouses.map(warehouse => warehouse.id)//.join(','),
                },
                mapperFilter: this.mapFilter,
                paramFilter: {
                    report: false,
                    wh_product_id: this.product.id,
                    //wh_warehouse_id: 
                },
            }
        },

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            warehouses: [],
            dialog: false,
            product: {},
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         * Gets the first warehouse.
         *
         * @return     {<type>}  The first warehouse.
         */
        getWarehouses() {
            return WarehouseModel
                .where('g_branch_office_id', this.user.hr_employee.g_branch_office_id)
                .get()
        },

        /**
         *
         */
        mapExcel(item) {
            return {
                Fecha: String(item.created_at),
                Producto: String(item.wh_product_name),
                Bodega: String(item.wh_warehouse_name),
                'Saldo Anterior': Number(item.stock_before || 0),
                'Saldo Posterior': Number(item.stock_after || 0),
            }
        },

        /**
         *
         */
        mapExcelDetailed(item) {
            return {
                Fecha: String(item.created_at),
                Producto: String(item.wh_product_name),
                Bodega: String(item.wh_warehouse_name),
                'Venta Sala': Number(item.normal_sale_total),
                'Venta Terreno': Number(item.ground_sale_total),
                'Ajuste Terreno': Number(item.stock_adjust_total),
                'Compras Terreno': Number(item.purchase_order_total),
                Reenvasado: Number(item.repacking_total),
                'Call Center': Number(item.call_center_sale_total),
                'Venta Empleado': Number(item.employee_sale_total),
                'Consumo Interno': Number(item.internal_consumption_total),
                'Cambio Producto': Number(item.change_product_customer_total),
            }
        },

        /**
         *
         */
        mapFilter(filter = {}) {
            //
            const hasEnd = !!filter.end
            const hasStart = !!filter.start
            const endString = String(filter.end)
            const startString = String(filter.start)

            //
            return {
                wh_warehouse_id: filter.wh_warehouse_id,
                between:
                    hasEnd && hasStart
                        ? startString
                              //.split('-')
                              //.reverse()
                              //.join('-')
                              .concat(',')
                              .concat(
                                  endString
                                  //.split('-')
                                  //.reverse()
                                  //.join('-')
                              )
                        : undefined,
                alias_name: filter.alias_name,
            }
        },

        /**
         *
         */
        printExcel(res) {
            this.generateXLSX(
                res.data.map(this.mapExcel),
                [],
                'Reporte de movimiento de stock'
            )
        },

        /**
         *
         */
        printExcelDetailed(res) {
            this.generateXLSX(
                res.data.map(this.mapExcelDetailed),
                [],
                'Reporte detallado de movimiento de stock'
            )
        },

        /**
         * Sets the first wh warehouse.
         *
         * @param      {<type>}  model   The model
         */
        setWarehouses(res) {
            this.warehouses = res.data
        },

        /**
         *
         */
        submitDetail(event) {
            this.selected = event.item
            this.dialog = true
        },

        /**
         *
         */
        submitExcel() {
            if (!this.product.id) {
              return this.showErrorSnackbar('Primero debe seleccionar un producto.')
            }
            //
            const whStockMovement = new StockMovementModel({ id: 'excel' })
            //
            whStockMovement
                .excel('', {
                  filter: {
                    ...this.$refs.table.currentFilter,
                    report: undefined,
                  }
                })
                .then(whStockMovement.showFile(`${this.product.name}-${new Date(Date.now()).toLocaleString()}`, 'xlsx'))
        },

        /**
         *
         */
        submitExcelDetailed() {
            StockMovementModel.modeler()
                .params(this.currentParams)
                .where('wh_product_id', this.product)
                .where('report', true)
                .get()
                .then(this.printExcelDetailed)
        },
    },
    mixins: [xlsxUtils],
    mounted() {
        this.getWarehouses()
            .then(this.setWarehouses)
    },
    beforeMount() {
        this.setTitleTopBar('Movimientos de inventario')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_MOVEMENT_INVENTORY')) ctx.$router.push('/')
        })
    },
}
